export const categories = [
  { value: 'all', label: 'All Categories', color: '#9ACD9A' },
  { value: 'homegrown', label: 'Homegrown Produce', color: '#4ECDC4' },
  { value: 'fruits', label: 'Fruits', color: '#FF6B6B' },
  { value: 'vegetables', label: 'Vegetables', color: '#45B7D1' },
  { value: 'eggs', label: 'Eggs', color: '#F7DC6F' },
  { value: 'honey', label: 'Honey & Preserves', color: '#F5B041' },
  { value: 'baked_goods', label: 'Baked Goods', color: '#AF7AC5' },
  { value: 'flowers', label: 'Flowers & Plants', color: '#E91E63' },
  { value: 'homemade', label: 'Homemade Crafts', color: '#FF6B6B' },
  { value: 'upcycled', label: 'Upcycled Items', color: '#FFE66D' },
  { value: 'secondhand', label: 'Secondhand Goods', color: '#DDA15E' },
  { value: 'library', label: 'Library', color: '#5D4E8C' },
  { value: 'other', label: 'Other', color: '#95A5A6' },
];
